import {Grid, Skeleton} from '@mui/material';

export const ReminderDrawerSkeleton = () => {
    return (
        <Grid container padding={'20px'} spacing={3}>
            <Grid item xs={12}>
                <Skeleton
                    style={{borderRadius: '10px', marginBottom: '10px'}}
                    variant="rectangular"
                    height={20}
                    width="100%"
                />
                <Skeleton
                    style={{borderRadius: '10px', marginBottom: '10px'}}
                    variant="rectangular"
                    height={120}
                    width="100%"
                />
            </Grid>
            <Grid item xs={12}>
                <Skeleton
                    style={{borderRadius: '10px', marginBottom: '10px'}}
                    variant="rectangular"
                    height={20}
                    width="100%"
                />
                <Skeleton
                    style={{borderRadius: '10px', marginBottom: '10px'}}
                    variant="rectangular"
                    height={120}
                    width="100%"
                />
            </Grid>
            <Grid item xs={12}>
                <Skeleton
                    style={{borderRadius: '10px', marginBottom: '10px'}}
                    variant="rectangular"
                    height={20}
                    width="100%"
                />
                <Skeleton
                    style={{borderRadius: '10px', marginBottom: '10px'}}
                    variant="rectangular"
                    height={120}
                    width="100%"
                />
            </Grid>
        </Grid>
    );
};

export default ReminderDrawerSkeleton;
